export default __webpack_public_path__ + "static/media/hht1_ep3_minisitcom_02.f8437016.png";